import { useEffect, useState } from "react";
import { Smartphone, X, Share } from "lucide-react";

const DISMISS_KEY = "sb_install_dismissed";
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(() => window.__sbInstallEvent || null);
  const [hidden, setHidden] = useState(() => isStandalone() || localStorage.getItem(DISMISS_KEY) === "1");
  const [showIos, setShowIos] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setHidden(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (hidden || (!deferred && !isIOS())) return null;

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") setHidden(true);
      setDeferred(null);
    } else setShowIos(true);
  };
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setHidden(true); };

  return (
    <div className="card-surface border-emerald-500/40 p-4 flex items-start gap-3" data-testid="install-prompt">
      <Smartphone className="text-emerald-400 shrink-0 mt-0.5" size={22} />
      <div className="flex-1 space-y-2">
        <p className="text-sm text-slate-200"><b>Installa Social Betting</b> sulla schermata Home e aprila come un'app.</p>
        {showIos ? (
          <p className="text-xs text-slate-400" data-testid="install-ios-help">Tocca <Share size={12} className="inline" /> <b>Condividi</b> in Safari, poi <b>Aggiungi alla schermata Home</b>.</p>
        ) : (
          <button onClick={install} data-testid="install-app-button" className="h-9 px-4 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0A0D14] text-sm font-bold">Installa l'app</button>
        )}
      </div>
      <button onClick={dismiss} data-testid="install-dismiss-button" className="h-8 w-8 grid place-items-center text-slate-500 hover:text-white" title="Chiudi"><X size={16} /></button>
    </div>
  );
};
